import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-slot-cilinder-vervangen"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Slot- en cilindervervanging"
    />
  );
}